import Button, { ButtonProps } from "@mui/material/Button";
import { colors } from "../../styles";

export type CustomBtnProps = {
  btntype?: "primary" | "secondary";
  width?: string;
  fullWidth?: boolean;
  noMargin?: boolean;
  backgroundColor?: string;
  textColor?: string;
} & ButtonProps;

const calcWidth = (fullWidth?: boolean, width?: string) => {
  if (width) return width;
  if (fullWidth) return "100%";
  return "auto";
};

const calcBackgroundColor = (
  btntype?: CustomBtnProps["btntype"],
  backgroundColor?: string
) => {
  if (backgroundColor) return backgroundColor;
  if (btntype === "primary") return colors.black;
  if (btntype === "secondary") return colors.white;
  return colors.black;
};

const calcColor = (btntype?: CustomBtnProps["btntype"], color?: string) => {
  if (color) return color;
  if (btntype === "primary") return colors.white;
  if (btntype === "secondary") return colors.black;
  return colors.white;
};

const CustomButton = (props: CustomBtnProps) => {
  const {
    btntype = "primary",
    width,
    fullWidth = true,
    noMargin,
    backgroundColor,
    textColor,
  } = props;
  return (
    <Button
      sx={{
        // common styles
        width: calcWidth(fullWidth, width),
        margin: noMargin ? "0" : "40px auto 0px",
        fontSize: "14px",
        boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.12)",
        borderRadius: "4px",
        textAlign: "center",
        textTransform: "none",
        cursor: "pointer",
        transition: "0.4s",
        // dependent styles
        backgroundColor: calcBackgroundColor(btntype, backgroundColor),
        color: calcColor(btntype, textColor),
        border: btntype === "primary" ? 0 : `1px solid ${colors.gray_200}`,
        "&:hover": {
          backgroundColor: calcBackgroundColor(btntype, backgroundColor),
          opacity: 0.75,
        },
        "&:disabled": {
          color: btntype === "primary" ? colors.white : colors.black,
          opacity: 0.25,
        },
        ...props.sx,
      }}
      style={props.style}
      disabled={props.disabled}
      onClick={props.onClick}
      type={props.type}
    >
      {props.children}
    </Button>
  );
};

export default CustomButton;
